var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0869141,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#556EE6",
    fillOpacity: 0.1804
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48972 13.8237H10.0147V13.0274C10.0147 12.4677 10.3232 12.1676 10.8937 12.1676H13.0473C13.6178 12.1676 13.9263 12.4677 13.9263 13.0274V13.8237H15.2359V13.0274C15.2359 12.4677 15.5444 12.1676 16.1381 12.1676H18.1812C18.7808 12.1676 19.0893 12.4677 19.0893 13.0274V13.8237H20.6143V12.1676C20.6143 11.0713 20.0206 10.5 18.9379 10.5H10.1661C9.08343 10.5 8.48972 11.0713 8.48972 12.1676V13.8237ZM7.052 19.9922C7.052 20.3038 7.25573 20.5 7.56423 20.5H7.92511C8.23361 20.5 8.43733 20.3038 8.43733 19.9922V19.1613C8.50718 19.1786 8.71091 19.1901 8.85643 19.1901H20.2476C20.3931 19.1901 20.5968 19.1786 20.6667 19.1613V19.9922C20.6667 20.3038 20.8704 20.5 21.1789 20.5H21.5398C21.8483 20.5 22.052 20.3038 22.052 19.9922V16.4838C22.052 15.3355 21.4117 14.7066 20.2476 14.7066H8.85643C7.69228 14.7066 7.052 15.3355 7.052 16.4838V19.9922Z",
    fill: "#556EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.d43df80b.svg";
export { ForwardRef as ReactComponent };